"use client";

import StudyingProgressCard from "@/features/StudyPages/components/StudyingProgressCard/StudyingProgressCard";
import { borderRadius } from "@/utils/borderRadius";
import { FlashcardSet, StudySession, StudySessionProgressEnum, StudySessionType } from "@knowt/syncing/graphql/schema";
import { useStudySession } from "@knowt/syncing/hooks/study/useStudySession";
import { createQueryStrings } from "@knowt/syncing/utils/genericUtils";
import { useRouter } from "@bprogress/next";
import { mutate } from "swr";

const SetOverviewStudyingProgress = ({
    flashcardSet,
    userId,
    serverStudySession,
}: {
    flashcardSet: FlashcardSet;
    userId?: string;
    serverStudySession: StudySession | null | undefined;
}) => {
    const flashcardSetId = flashcardSet.flashcardSetId;
    const router = useRouter();

    const { studySession, isCommittingUpdates } = useStudySession({
        flashcardSetId: flashcardSet.flashcardSetId,
        type: StudySessionType.LEARN,
        fallbackData: serverStudySession,
    });

    const handleLearnMode = async (studyFrom?: StudySessionProgressEnum) => {
        await mutate(["round-data", userId, flashcardSetId, StudySessionType.LEARN], null, { revalidate: false });
        router.push(`/study/flashcards/${flashcardSetId}/learn${createQueryStrings({ studyFrom })}`);
    };

    return (
        <StudyingProgressCard
            flashcardSetId={flashcardSet.flashcardSetId}
            studySession={studySession}
            isCommittingUpdates={isCommittingUpdates}
            total={flashcardSet.flashcards?.length}
            style={{ borderRadius: borderRadius.card, width: "100%" }}
            onStudy={studyFrom => handleLearnMode(studyFrom)}
            withStats={!!flashcardSet.classId}
        />
    );
};

export default SetOverviewStudyingProgress;
